/*
 * Custom scripts.
 *
 * @author Julian Pollak <j.pollak@fruitcake.ch>
 * @copyright 2017-2019 by Fruitcake Websolutions (fruitcake.ch)
 */


!function ($) {
    $(function () {
        // Lightbox gallery
        $('.mgd-gallery-images.mgd-lightbox').each(function () {
            $(this).magnificPopup({
                delegate: 'a',
                type: 'image',
                gallery: {
                    enabled: true,
                }
            });
        });

        // People lightbox
        $('.mgd-people-list').each(function () {
            $(this).magnificPopup({
                delegate: 'a',
                type: 'image',
                gallery: {
                    enabled: true,
                }
            });
        });

        // Auto-buttons for isolated links inside paragraphs
        $('p > a').each(function() {
            var $this = $(this);
            var $paragraph = $this.closest('p');

            if ($paragraph.text().length - $this.text().length === 0) {
                $this.addClass('btn').addClass('btn-primary');
            }
        });

        // Page header slider
        $('#mgd-page-header-slider').each(function() {
            $(this).slick({
                infinite: true,
                autoplay: true,
                pauseOnHover: true,
                autoplaySpeed: 8000,
                speed: 1250,
                swipe: false,
                rows: 0,
                dots: true,
                arrows: false,
            });
        });
    });
}(jQuery);
